<button type="button" class="link" (click)="clear.emit()">
  <span class="tw:underline"><ng-content></ng-content></span>
  <fr8bot-ui-icon name="x-1-12" [size]="12" />
</button>
